export const FREE_CANCELLATION_BENEFIT_MOBILE = "PRIME_OPRIME2532M";
export const FREE_CANCELLATION_BENEFIT_DESKTOP = "PRIME_OPRIME2532D";
export const FREE_CANCELLATION_DESKTOP_WAITING_PAGE = "PRIME_OPRIME4235";
export const REMOVE_LINK_REMOVE_PRIME = "PRIME_OPRIME3164";

export const oprimeAliases = {
  freeCancellationBenefitMobileVersionedComponent:
    FREE_CANCELLATION_BENEFIT_MOBILE,
  freeCancellationDesktopVersionedComponent: FREE_CANCELLATION_BENEFIT_DESKTOP,
  freeCancellationDesktopWaitingPageComponent:
    FREE_CANCELLATION_DESKTOP_WAITING_PAGE,
  removeLinkRemovePrimeVersionedComponent: REMOVE_LINK_REMOVE_PRIME,
};

export const aliases = Object.values(oprimeAliases);
